var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.tabList
    ? _c(
        "div",
        { staticClass: "tab" },
        _vm._l(_vm.tabList, function(tab, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "tab__item",
              class: {
                activeTab: _vm.activeTab.value == _vm.tabList[index].value
              },
              on: {
                click: function($event) {
                  _vm.activeTab = _vm.tabList[index]
                }
              }
            },
            [_vm._v("\n    " + _vm._s(_vm.tabList[index].label) + "\n  ")]
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }